'use strict';

module.exports = (app) => app.directive('loadingInlineIndicator', /* @ngInject */ function() {
    return {
        restrict: 'EA',
        scope: {
            isLoading: '=',
        },
        template: '<img ng-show="isLoading" alt="Loading..." src="img/loadingAnimation.gif">'
    };
});
